import { z } from 'zod';
import {
  GENERATION_QUEUE_FAILURE_CATEGORIES,
  GENERATION_QUEUE_ITEM_STATUSES,
  GENERATION_QUEUE_STATE_STATUSES,
} from '../constants.js';
import { CreateRunRequestSchema } from './runs.js';

const utcDateTimeSchema = z.string().datetime({ offset: true });
const nullableUuidSchema = z.string().uuid().nullable();
const nullableFailureCategorySchema = z.enum(GENERATION_QUEUE_FAILURE_CATEGORIES).nullable();

export const GenerationQueueItemStatusSchema = z.enum(GENERATION_QUEUE_ITEM_STATUSES);

export const GenerationQueueStateStatusSchema = z.enum(GENERATION_QUEUE_STATE_STATUSES);

export const GenerationQueueFailureCategorySchema = z.enum(GENERATION_QUEUE_FAILURE_CATEGORIES);

export const CreateGenerationQueueItemRequestSchema = z.object({
  brief: CreateRunRequestSchema,
});
export type CreateGenerationQueueItemRequest = z.infer<
  typeof CreateGenerationQueueItemRequestSchema
>;

export const GenerationQueueItemResponseSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  position: z.number().int().nonnegative(),
  status: GenerationQueueItemStatusSchema,
  brief: CreateRunRequestSchema,
  attempts: z.number().int().nonnegative().default(0),
  maxAttempts: z.number().int().min(1).max(3).default(3),
  activeRunId: nullableUuidSchema,
  lastRunId: nullableUuidSchema,
  lastError: z.string().nullable(),
  lastErrorCategory: nullableFailureCategorySchema,
  createdAt: utcDateTimeSchema,
  updatedAt: utcDateTimeSchema,
  startedAt: utcDateTimeSchema.nullable(),
  completedAt: utcDateTimeSchema.nullable(),
});
export type GenerationQueueItemResponse = z.infer<typeof GenerationQueueItemResponseSchema>;

export const GenerationQueueStateResponseSchema = z.object({
  userId: z.string().uuid(),
  status: GenerationQueueStateStatusSchema,
  pauseReasonCategory: nullableFailureCategorySchema,
  pauseReason: z.string().nullable(),
  pausedAt: utcDateTimeSchema.nullable(),
  createdAt: utcDateTimeSchema,
  updatedAt: utcDateTimeSchema,
});
export type GenerationQueueStateResponse = z.infer<typeof GenerationQueueStateResponseSchema>;

export const GenerationQueueResponseSchema = z.object({
  ok: z.literal(true),
  state: GenerationQueueStateResponseSchema,
  items: z.array(GenerationQueueItemResponseSchema),
});
export type GenerationQueueResponse = z.infer<typeof GenerationQueueResponseSchema>;

export const ReorderGenerationQueueRequestSchema = z.object({
  itemIds: z.array(z.string().uuid()).min(1),
});
export type ReorderGenerationQueueRequest = z.infer<typeof ReorderGenerationQueueRequestSchema>;
